import { useState } from "react";
import { CNav, CNavItem, CNavLink, CTabContent } from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";
import { TextMS } from "../../common/text";
import TicketDetailTabContent from "./TicketDetailTabContent";

const TicketDetailTab = ({ ticket, isUsedTicket }) => {
  const [activeKey, setActiveKey] = useState(1);
  return (
    <>
      <CNav variant="tabs" role="tablist">
        <CNavItem>
          <CNavLink
            active={activeKey === 1}
            style={{
              backgroundColor: activeKey === 1 ? "rgba(250,250,250,0.8)" : "",
            }}
            onClick={() => setActiveKey(1)}
          >
            <TextMS>상세정보</TextMS>
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink
            active={activeKey === 2}
            style={{
              backgroundColor: activeKey === 2 ? "rgba(250,250,250,0.8)" : "",
            }}
            onClick={() => setActiveKey(2)}
          >
            <TextMS>환불규정</TextMS>
          </CNavLink>
        </CNavItem>
      </CNav>
      <CTabContent
        style={{ height: isUsedTicket ? "100%" : "70%", overflow: "scroll" }}
      >
        <TicketDetailTabContent
          activeKey={activeKey}
          ticket={ticket}
        ></TicketDetailTabContent>
      </CTabContent>
    </>
  );
};

export default TicketDetailTab;
